import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from '@angular/router';
import { PrincipalService } from '@app/principal/service/principal.service';
import { REAL_PROPERTY_FILTER } from '@app/real-property-list-filter/models';
import * as services from '@app/real-property-list-filter/services';
import { SettingsService } from '@app/settings.service';
import { ButtonComponent } from '@app/shared/button/button.component';
import { HeaderSliderComponent } from '@app/shared/header-slider/header-slider.component';
import { DataFilterComponent } from '@app/shell/header/data-filter/data-filter.component';
import { FilterModalComponent } from '@app/shell/header/data-filter/filter-modal/filter-modal.component';
import { NavComponent } from '@app/shell/header/nav/nav.component';
import { HomeService } from '@modules/real-property-data/services';
import { RealPropertyService } from '@modules/real-property-details';
import { UserProfile } from '@modules/user';
import { AddressObject } from '@shared/models';
import { SelectComponent } from '@shared/modules/select/select.component';
import { AddressService, DictionaryService } from '@shared/services';
import { NgxMaskModule } from 'ngx-mask';
import { MenuItem } from 'primeng/api';
import { CarouselModule } from 'primeng/carousel';
import { DialogService } from 'primeng/dynamicdialog';
import { MenuModule } from 'primeng/menu';
import { combineLatest, Observable, of, Subject, switchMap, zip } from 'rxjs';
import { filter, map, take, takeUntil, tap } from 'rxjs/operators';
import { bumpIn } from '../../../styles/animations';
import { ApplyApplicationComponent } from '../apply-application/apply-application.component';
import { SignUpComponent } from '../sign-up/sign-up.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MenuModule,
    SelectComponent,
    ReactiveFormsModule,
    ButtonComponent,
    NavComponent,
    DataFilterComponent,
    SignUpComponent,
    NgxMaskModule,
    CarouselModule,
    HeaderSliderComponent,
    ApplyApplicationComponent,
],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [bumpIn],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showImage: boolean = false;

  @Output() nextPage: EventEmitter<any> = new EventEmitter<any>();

  citySelect: FormControl = new FormControl(1);
  cityCollection$: Observable<{ value: number; label: string }[]>;
  cityLoading$: Observable<boolean>;

  navButtons: { text: string; icon: string; active: boolean }[] = [];
  buttonState: 'down' | 'up' = 'down';
  navButtonsPage = 0;
  currentUser: UserProfile;
  showFilters = false;
  hideHeader: boolean = false;
  currency: any;
  temperature: any;

  isTablet$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  itemsUserOut: MenuItem[] = [
    {
      label: 'Войти',
      command: () => {
        this.login();
      },
    },
    {
      label: 'Избранные объекты',
      // routerLink: 'new-design/favorites',
      command: () => {
        this.redirectToNewPage('favorites');
      },
    },
    {
      label: 'Наши специалисты',
      command: () => {
        this.redirectToNewPage('our-specialists');
      },
    },
    {
      label: 'Сохраненные поиски',
      command: () => {
        this.redirectToNewPage('save-search');
      },
    },
  ];
  public itemsUserIn: MenuItem[] = [
    // {
    //   label: null,
    //   routerLink: '/profile',
    // },
    {
      label: 'Личный кабинет',
      routerLink: '/account',
    },
    {
      label: 'Мои заявки',
      routerLink: '/my-application-list',
    },
    {
      label: 'Избранные объекты',
      command: () => {
        this.redirectToNewPage('favorites');
      },
    },
    {
      label: 'Наши специалисты',
      command: () => {
        this.redirectToNewPage('our-specialists');
      },
    },
    {
      label: 'Сохраненные поиски',
      command: () => {
        this.redirectToNewPage('save-search');
      },
    },
    {
      label: 'Выйти',
      command: () => {
        this.logout();
      },
      styleClass: 'exit-item',
    },
  ];
  message = 'Было продано за неделю 223 объектов';
  repeatArray = Array(20).fill(0);
  isShowAuthorization = false;
  isShowApplyApplication = false;

  headerIcons: { icon: string; link: string }[] = [
    { icon: 'assets/images/new-design-icons/Facebook_gray.svg', link: 'https://www.facebook.com/vitrina.nedvizhimosti' },
    { icon: 'assets/images/new-design-icons/Instagram_gray.svg', link: 'https://www.instagram.com/ivitrina.kz/?igshid=YmMyMTA2M2Y=' },
    { icon: 'assets/images/new-design-icons/Youtube_gray.svg', link: 'https://www.youtube.com/channel/UCTM82jnI4dx5o4HVMH-qMOw' },
  ];
  destroy$: Subject<any> = new Subject<any>();
  mainNumber = '7057559595';
  @ViewChild('carouselWrapper') carousel: any;

  constructor(
    private _addressService: AddressService,
    private _dictService: DictionaryService,
    private _complexService: services.ResidentialComplexService,
    private _settingsService: SettingsService,
    private _homeService: HomeService,
    private _realPropertyService: RealPropertyService,
    private _dialogService: DialogService,
    private _principalService: PrincipalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (localStorage.getItem('currency')) {
      this.currency = JSON.parse(localStorage.getItem('currency')).value;
    }
    this._principalService.currentUserSubject$
      .pipe(
        tap((user) => (this.currentUser = user)),
        filter((user) => !!user),
        takeUntil(this.destroy$),
      )
      .subscribe();
    this._dictService.getHouseConditions();
    this.isTablet$ = this._settingsService.isTablet();
    this.isMobile$ = this._settingsService.isMobile();

    this.cityCollection$ = this._addressService.cityList$.pipe(
      map((cities) => {
        return cities.map((city) => ({ value: city.id, label: city.name }));
      }),
    );
    this.cityLoading$ = this._addressService.cityLoading$;

    this._addressService.currentCity$
      .pipe(
        filter((c) => !!c),
        takeUntil(this.destroy$),
      )
      .subscribe((city) => {
        this.citySelect.setValue(city.id);
        this.buildNavButtons(city);
        this._settingsService.updateFiltersCount({ city: city.code, dealType: 2 });
      });

    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        switchMap((params) => zip(of(params), this.isMobile$)),
      )
      .subscribe(([ev, isMobile]) => {
        const currentRoute = this.getDeepestRoute(this.route);
        this.showImage = !currentRoute.snapshot.routeConfig?.path;
        if (ev.url.includes('real-property/')) {
          this.showFilters = false;
          this.hideHeader = isMobile;
        }
        if (ev.url === '/') {
          this.hideHeader = false;
          this.showFilters = true;
        }
      });

    this._settingsService.openLoginModal$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.login();
    });

    this._settingsService.openApplyApplicationModal$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // this.login();
      this.isShowApplyApplication = true;
    });

    // of(null).pipe(
    //     takeUntil(this.destroy$),
    //     filter(() => {
    //       let isUpdate = true;
    //       if (localStorage.getItem('currency')) {
    //         const nextDate = JSON.parse(localStorage.getItem('currency')).nextDate;
    //         isUpdate = moment(nextDate).isSameOrBefore(moment(), 'hour') && environment.production;
    //       }
    //       return this.router.url === '/' && isUpdate;
    //     }),
    //     switchMap(() => {
    //       return this._homeService.getCurrency();
    //     }),
    // ).subscribe((cur: any) => {
    //     this.currency = cur.conversion_rates;
    //     localStorage.setItem('currency', JSON.stringify({ value: cur.conversion_rates, nextDate: moment().add(1, 'days').toISOString() }));
    //   });

    this._addressService.currentCity$
      .pipe(
        filter((c) => !!c),
        takeUntil(this.destroy$),
        switchMap((res) => {
          return this._homeService.getWeather(res.translateNames.nameEn).pipe(takeUntil(this.destroy$));
        }),
      )
      .subscribe((data: any) => {
        this.temperature = data.current.temp_c;
      });
  }

  calculateCurrency(value: number) {
    return (1 / value).toFixed(0);
  }

  selectCity(cityId: number) {
    if (cityId === 661) {
      this.mainNumber = '7712288822';
    } else {
      this.mainNumber = '7057559595';
    }
    this._addressService.updateCurrentCity(cityId);
    this._addressService.updateCurrentDistricts([]);
  }

  login() {
    this.isShowAuthorization = true;
  }

  logout() {
    this._principalService.logout();
  }

  visiblePanelChange(event: boolean, type: 'isShowApplyApplication' | 'isShowAuthorization') {
    this[type] = event;
  }

  redirectToNewPage(page: string) {
    this.showImage = false;
    this.showFilters = false;
    this.router.navigate([`/${page}`]);
  }

  sendBidClick() {
    this._settingsService.openApplyApplicationModal();
  }

  get phoneNumber() {
    return this._settingsService.getPhoneCallNumber();
  }

  checkIsShowFilters() {
    return (
      !this.router.url.includes('/real-property/') &&
      !this.router.url.includes('/agent/') &&
      !this.router.url.includes('favorites') &&
      !this.router.url.includes('save-search') &&
      !this.router.url.includes('our-specialists') &&
      !this.router.url.includes('signing') &&
      !this.router.url.includes('history') &&
      !this.router.url.includes('academy') &&
      !this.router.url.includes('top-designer-flats') &&
      !this.router.url.includes('live') &&
      !this.router.url.includes('top-agents') &&
      !this.router.url.includes('top-team') &&
      !this.router.url.includes('team-detail/') &&
      !this.router.url.includes('news-portal')
    );
  }

  getDeepestRoute(route: ActivatedRoute): ActivatedRoute {
    return route.firstChild ? this.getDeepestRoute(route.firstChild) : route;
  }

  buildNavButtons(city: AddressObject) {
    this._addressService.districtLoaded$
      .pipe(
        filter((loaded) => loaded),
        takeUntil(this.destroy$),
        switchMap(() => this.route.queryParamMap),
        tap(() => {
          this.showFilters = this.checkIsShowFilters();
        }),
        switchMap((params) => zip(of(params), this.isMobile$)),
        tap(([params, isMobile]) => {
          this.hideHeader = isMobile && !!this.router.url.match('real-property/(\\d+)$');
        }),
        filter(() => this.showFilters),
      )
      .subscribe(([params, isMobile]) => {
        const currentRoute = this.getDeepestRoute(this.route);
        this.showImage = !currentRoute.snapshot?.routeConfig?.path;
        const isNew =
          params.keys.length === 2 ||
          ((params.has('housingConditionIds') ? !params.getAll('housingConditionIds').length : false) &&
            (params.has('residentialComplexIds') ? !params.getAll('residentialComplexIds').length : false));
        this.navButtons = [
          { text: 'Главная', icon: 'assets/images/new-design-icons/nav-icons/main.svg', active: !params.keys.length },
          { text: 'Дизайн', icon: 'assets/images/new-design-icons/nav-icons/design.svg', active: params.has('housingConditionIds') && params.getAll('housingConditionIds')[0] === '3' },
          { text: 'Студия', icon: 'assets/images/new-design-icons/nav-icons/studio.svg', active: !!params.get('atelier') },
          { text: 'Черновой', icon: 'assets/images/new-design-icons/nav-icons/rough-repair.svg', active: params.has('housingConditionIds') && params.getAll('housingConditionIds')[0] === '4' },
          {
            text: 'Новинки',
            icon: 'assets/images/new-design-icons/nav-icons/news.svg',
            active: isNew && params.has('addressCodes') && params.getAll('addressCodes').length === 1 && params.getAll('addressCodes')[0] === '001001',
          },
        ];
        if (isMobile) {
          this.navButtons.unshift({ text: 'Фильтр', icon: 'assets/images/new-design-icons/filters-white.svg', active: false });
        }
        if (city.id === 1) {
          this.navButtons.push(
            {
              text: 'Левый берег',
              icon: 'assets/images/new-design-icons/nav-icons/left-shore.svg',
              active: params.has('addressCodes') && params.getAll('addressCodes').length === 2 && params.getAll('addressCodes')[0] === '001001010' && params.getAll('addressCodes')[1] === '001001020',
            },
            {
              text: 'Правый берег',
              icon: 'assets/images/new-design-icons/nav-icons/right-shore.svg',
              active:
                params.has('addressCodes') &&
                params.getAll('addressCodes').length === 3 &&
                params.getAll('addressCodes')[0] === '001001007' &&
                params.getAll('addressCodes')[1] === '001001002' &&
                params.getAll('addressCodes')[2] === '001001003',
            },
          );
        }
        this.setDataToStore(params);
      });
  }

  setDataToStore(params: ParamMap) {
    const countObj = {};
    if (params.has('housingConditionIds') && params.getAll('housingConditionIds').length) {
      this._dictService.updateCurrentHouseCondition([+params.getAll('housingConditionIds')[0]]);
      this._settingsService.updateFiltersCount({ condition: +params.getAll('housingConditionIds')[0] });
      countObj['housingConditionIds'] = [+params.getAll('housingConditionIds')[0]];
    }
    if (params.has('atelier')) {
      this._settingsService.updateFilters({ layout: params.get('atelier') });
      this._settingsService.updateFiltersCount({ layout: params.get('atelier') });
      countObj['atelier'] = params.get('atelier');
    }
    if (params.has('addressCodes')) {
      if (params.getAll('addressCodes').length == 2) {
        this._addressService.updateCurrentDistricts([173, 60048]);
        this._settingsService.updateFiltersCount({ district: [173, 60048] });
        this.navButtonsPage = 1;
      } else if (params.getAll('addressCodes').length == 3) {
        this._addressService.updateCurrentDistricts([2, 121, 138]);
        this._settingsService.updateFiltersCount({ district: [2, 121, 138] });
        this.navButtonsPage = 1;
      }
      countObj['addressCodes'] = params.getAll('addressCodes');
    }
    this._realPropertyService.getRealPropertyCountDispatch(countObj);
  }

  searchData(button: any) {
    this.navButtons.forEach((b) => {
      if (button.text === b.text) {
        b.active = true;
      } else {
        b.active = false;
      }
    });
    if (button.text === 'Главная') {
      this.redirectHome();
      return;
    }
    if (button.text === 'Фильтр') {
      this.openMoreFilters();
      return;
    }
    this.nextPage.emit();
  }

  openMoreFilters() {
    let dialog: any = null;
    combineLatest([
      this._addressService.currentCity$.pipe(map((c) => c.id)),
      this._addressService.currentStreets$.pipe(map((st) => st.map((s) => s.id))),
      this._addressService.currentDistricts$.pipe(map((dt) => dt.map((s: any) => s.id))),
      this._dictService.currentHouseConditions$.pipe(map((st: any[]) => st.map((s) => s.id))),
      this._complexService.currentComplex$.pipe(map((st) => st.map((s: any) => s.id))),
      this._dictService.currentObjectTypeId$,
      this._settingsService.currentFilters$,
    ])
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(([city, street, district, condition, complex, objectTypes, filters]) => {
        const currentFilters: any = {
          dealType: filters.dealType.value,
          realtyType: objectTypes,
          priceFrom: filters.price.from,
          priceTo: filters.price.to,
          areaFrom: filters.area.from,
          areaTo: filters.area.to,
          roominess: filters.roominess,
          proposalId: filters.proposalId,
          constructYearFrom: filters.constructYear.from,
          constructYearTo: filters.constructYear.to,
          city: city,
          complex: complex,
          district: district,
          street: street,
          layout: filters.layout,
          condition: condition,
        };
        dialog = this._dialogService.open(FilterModalComponent, {
          modal: true,
          autoZIndex: false,
          showHeader: false,
          closable: true,
          styleClass: 'filter-dialog',
          data: { filters: currentFilters },
          dismissableMask: true,
        });
      });

    if (dialog) {
      dialog.onClose.subscribe(({ action }: { action: any }) => {
        if (action === 'search') {
          this.nextPage.emit();
        }
        if (action === 'save') {
          // this.saveSearch();
        }
      });
    }
  }

  redirectHome() {
    this.showImage = true;
    this._settingsService.clearFilter();
    this._realPropertyService.getRealPropertyCountDispatch(REAL_PROPERTY_FILTER());
    this.router.navigate(['/']);
  }

  redirectToLink(link: string) {
    document.location.href = link;
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  bannerEvent(image: string) {
    if (image.includes('image-7')) {
      this.isShowApplyApplication = true;
    } else if (image.includes('image-1')) {
      this.router.navigate(['/top-agents']);
    }
  }
}
